
import { PlayerEventType, PlayerEventStateType } from '../model/playerEventModel';
import { isNotDocumentSession } from './gotoPageHandler';

let engagementViewerLoadComplete = null;
const attributeRecord = new Map();
export const setNewrelicCustomAttribute = async (attributeName, value) => {
    try {
        if (window.newrelic && !attributeRecord.get(attributeName)) {
            attributeRecord.set(attributeName, value);
            window.newrelic.setCustomAttribute(attributeName, value);
        }
    } catch (ex) {
        console.log(ex.toString());
    }
};

export const setNewrelicTracer = async () => {
    try {
        if (window.newrelic && window.newrelic.interaction && !engagementViewerLoadComplete) {
            engagementViewerLoadComplete = window.newrelic
                .interaction()
                .createTracer('engagementViewerLoadComplete', () => {
                    engagementViewerLoadComplete = null;
                });
        }
    } catch (ex) {
        console.log(ex.toString());
    }
};

export const getNewrelicTracer = () => {
    if (window.newrelic && engagementViewerLoadComplete) {
        return engagementViewerLoadComplete;
    }

    return null;
};

export const executeNewrelicTracerForContent = async (event) => {
    try {
        if (engagementViewerLoadComplete) {
            if ((event.stateType === PlayerEventStateType.ContentPage && event.state - 1 === 0) ||
            (event.eventType === PlayerEventType.StartSession && isNotDocumentSession(event))) {
                engagementViewerLoadComplete();
            }
        }
    } catch (ex) {
        console.log(ex.toString());
    }
};

export const executeNewrelicTracerForOthers = async () => {
    if (engagementViewerLoadComplete) {
        engagementViewerLoadComplete();
    }
};

